<template>
    <div style="background-color:#FFF" v-if="loaded" class="print-label-container">

        <div class="driver-label" v-for="label in label_list">
            <div class="driver-label-qr">
                <qr-code :text="label.qr" :size="160" style="max-width: 80px;"></qr-code>
            </div>
            <div>
                <div class="driver-label-code">{{label.code}}</div>
                <div class="driver-label-name">{{label.name}}</div>
            </div>

        </div>
    </div>
</template>

<script>
    import VueQRCodeComponent from 'vue-qr-generator'
    export default {
        components: {
            'qr-code': VueQRCodeComponent,
        },
        created() {
            this.getDriver();
            printers.PrinterService.requestPrinter();
        },
        mounted() { },
        data() {
            return {
                loaded: false,
                hash_id: "",
                name: "",
                label_list: []
            }
        },
        methods: {
            getDriver() {
                this.$http.get(this.config.api + "/admin/driver/get/" + this.$route.params.hash_id).then(data => {
                    this.hash_id = data.body.data.hash_id
                    this.name = data.body.data.name

                    for (let i = 0; i < 3; i++) {
                        let code = this.hash_id + "-" + this.config.generate(12);
                        let qr = this.config.encrypt(code);
                        let name = this.name;
                        this.label_list.push({ qr: qr, code: code, name: name });
                    }

                    this.loaded = true;
                    setTimeout(() => {

                        window.print();
                        var self = this;
                        window.addEventListener('afterprint', () => {
                            self.$router.back();
                        });

                    }, 1000)
                })
            }
        }
    }
</script>

<style>

    /* @media print {
        body {
            page: driver-label;
        }
    } */

    .driver-label {
        box-sizing: border-box;
        /* border: 1px solid #EEE; */
        width: 50mm;
        height: 34mm;
        page-break-after: always;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .driver-label-qr {
        display: flex;
        flex-direction: row;
        justify-content: center;
        margin-bottom: 10px;
    }

    .driver-label-code {
        text-align: center;
        font-size: 11px;
        line-height: 11px;
    }

    .driver-label-name {
        text-align: center;
        font-size: 8px;
        line-height: 15px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/PrintDriverPackageLabel.vue